import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Roles } from '@nrwl/rx-models';
import { RxRoleGuardDirective } from '@org/rx-directives';
import { RxIconComponent } from '../../rx-icon/rx-icon.component';
import { RxListPhotoItemComponent } from '../rx-list-photo-item';

@Component({
  selector: 'rx-list-gif-item',
  templateUrl: './rx-list-gif-item.component.html',
  styleUrls: ['./rx-list-gif-item.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    RxIconComponent,
    MatIconModule,
    MatMenuModule,
    MatCheckboxModule,
    RxRoleGuardDirective,
  ],
})
export class RxListGifItemComponent
  extends RxListPhotoItemComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input()
  public previewUrl: string;

  @Input()
  public gifUrl: string;

  @Input()
  public showCheckbox = false;

  @Input()
  public rejectedRoles: Roles[] = [];

  public isAnimated = false;
  public proportionalHeight: number;
  private resizeObserver: ResizeObserver;

  @HostListener('window:resize', ['$event.target'])
  public onResize() {
    this.recalculateHeight();
  }

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _el: ElementRef,
  ) {
    super(_changeDetection);
  }

  public override get image() {
    return this.isAnimated ? this.gifUrl : this.previewUrl;
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.resizeObserver?.disconnect();
  }

  public ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(() => {
      this.recalculateHeight();
      this._changeDetection.markForCheck();
    });
    this.resizeObserver.observe(this._el.nativeElement);
  }

  public toggleAnimation(event) {
    event.stopImmediatePropagation();
    this.isAnimated = !this.isAnimated;
  }

  public recalculateHeight() {
    this.proportionalHeight = this._el.nativeElement.getBoundingClientRect().width / 1.5;
  }
}
